import { useQuery } from "@tanstack/react-query";
import { useServices } from "index"

export const useGetNumberOfInvitesLeft = (organizationId: string) => {
  const inviteStudentsService = useServices().inviteStudentsService;
  return useQuery({
    queryKey: ['numberOfInvitesLeft', organizationId],
    queryFn: () => inviteStudentsService.getNumberOfInvitesLeft(organizationId),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
}